import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_474c533f from 'nuxt_plugin_plugin_474c533f' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_3d617a7d from 'nuxt_plugin_cookieuniversalnuxt_3d617a7d' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_10581ceb from 'nuxt_plugin_gtm_10581ceb' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescreen_8fa8f020 from 'nuxt_plugin_vuescreen_8fa8f020' // Source: ./vue-screen.js (mode: 'all')
import nuxt_plugin_markdownit_88915a6e from 'nuxt_plugin_markdownit_88915a6e' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_dayjsplugin_490c8a68 from 'nuxt_plugin_dayjsplugin_490c8a68' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_7859ee06 from 'nuxt_plugin_pluginutils_7859ee06' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7f9711d1 from 'nuxt_plugin_pluginrouting_7f9711d1' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_d1cad984 from 'nuxt_plugin_pluginmain_d1cad984' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuedaumpostcode_79a614cd from 'nuxt_plugin_vuedaumpostcode_79a614cd' // Source: ./vue-daum-postcode.js (mode: 'client')
import nuxt_plugin_axios_884bb656 from 'nuxt_plugin_axios_884bb656' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_63d3f13a from 'nuxt_plugin_moment_63d3f13a' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_deviceplugin_52fe1760 from 'nuxt_plugin_deviceplugin_52fe1760' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_index_e8a85358 from 'nuxt_plugin_index_e8a85358' // Source: ../plugins/axios/index.js (mode: 'all')
import nuxt_plugin_actChart_0d097f3c from 'nuxt_plugin_actChart_0d097f3c' // Source: ../plugins/axios/actChart.js (mode: 'all')
import nuxt_plugin_vueinfiniteloading_5f280597 from 'nuxt_plugin_vueinfiniteloading_5f280597' // Source: ../plugins/vue-infinite-loading.js (mode: 'client')
import nuxt_plugin_vueemojipicker_799f5465 from 'nuxt_plugin_vueemojipicker_799f5465' // Source: ../plugins/vue-emoji-picker.js (mode: 'all')
import nuxt_plugin_vueuuid_76fc2442 from 'nuxt_plugin_vueuuid_76fc2442' // Source: ../plugins/vue-uuid.js (mode: 'all')
import nuxt_plugin_vueyoutube_6da200de from 'nuxt_plugin_vueyoutube_6da200de' // Source: ../plugins/vue-youtube.js (mode: 'all')
import nuxt_plugin_vuecssdonutchart_d9faf16a from 'nuxt_plugin_vuecssdonutchart_d9faf16a' // Source: ../plugins/vue-css-donut-chart.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_vawesomeswiper_3c4ab670 from 'nuxt_plugin_vawesomeswiper_3c4ab670' // Source: ../plugins/v-awesome-swiper.js (mode: 'client')
import nuxt_plugin_vlazyload_026ea236 from 'nuxt_plugin_vlazyload_026ea236' // Source: ../plugins/v-lazy-load.js (mode: 'all')
import nuxt_plugin_vmasonry_b03acc82 from 'nuxt_plugin_vmasonry_b03acc82' // Source: ../plugins/v-masonry.js (mode: 'client')
import nuxt_plugin_vfriendlyiframe_bc350d44 from 'nuxt_plugin_vfriendlyiframe_bc350d44' // Source: ../plugins/v-friendly-iframe.js (mode: 'all')
import nuxt_plugin_vtoastification_598b949a from 'nuxt_plugin_vtoastification_598b949a' // Source: ../plugins/v-toastification.js (mode: 'client')
import nuxt_plugin_vuejsdatepicker_061a20f2 from 'nuxt_plugin_vuejsdatepicker_061a20f2' // Source: ../plugins/vuejs-datepicker.js (mode: 'client')
import nuxt_plugin_vuescrollpicker_5fb780ff from 'nuxt_plugin_vuescrollpicker_5fb780ff' // Source: ../plugins/vue-scrollpicker.js (mode: 'client')
import nuxt_plugin_vue2datepicker_4e082fe0 from 'nuxt_plugin_vue2datepicker_4e082fe0' // Source: ../plugins/vue2-datepicker.js (mode: 'all')
import nuxt_plugin_vkakaosdk_ea765698 from 'nuxt_plugin_vkakaosdk_ea765698' // Source: ../plugins/v-kakao-sdk.js (mode: 'client')
import nuxt_plugin_vue2touchevent_00a83936 from 'nuxt_plugin_vue2touchevent_00a83936' // Source: ../plugins/vue2-touch-event.js (mode: 'all')
import nuxt_plugin_fontawesomeicons_36ca5133 from 'nuxt_plugin_fontawesomeicons_36ca5133' // Source: ../plugins/font_awesome_icons.js (mode: 'client')
import nuxt_plugin_vuetify_d6afc2c2 from 'nuxt_plugin_vuetify_d6afc2c2' // Source: ../plugins/vuetify.js (mode: 'all')
import nuxt_plugin_gtm_63638066 from 'nuxt_plugin_gtm_63638066' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_gtag_0a2cb1e4 from 'nuxt_plugin_gtag_0a2cb1e4' // Source: ../plugins/gtag.js (mode: 'client')
import nuxt_plugin_dataDog_86d7e10a from 'nuxt_plugin_dataDog_86d7e10a' // Source: ../plugins/dataDog.js (mode: 'all')
import nuxt_plugin_persistedState_1da1c1a3 from 'nuxt_plugin_persistedState_1da1c1a3' // Source: ../plugins/persistedState.js (mode: 'client')
import nuxt_plugin_commonRouter_58daaba6 from 'nuxt_plugin_commonRouter_58daaba6' // Source: ../plugins/commonRouter.js (mode: 'all')
import nuxt_plugin_msw_4efc7088 from 'nuxt_plugin_msw_4efc7088' // Source: ../plugins/msw.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"MAKESTAR","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"title","content":"Makestar : Make Your Own Star!"},{"hid":"description","name":"description","content":"The K-Culture place everyone seeks first"},{"property":"og:title","content":"Makestar : Make Your Own Star!"},{"property":"og:description","content":"The K-Culture place everyone seeks first"},{"property":"og:image","content":"https:\u002F\u002Fmakeuni2026.com\u002Fimage\u002Fmakestar_logo_og_v2.png"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https:\u002F\u002Fmakeuni2026.com"},{"property":"twitter:card","content":"summary_large_image"},{"property":"twitter:title","content":"K-Portal : Make Your Own Star (K-pop,drama,movie)"},{"property":"twitter:description","content":"The K-Culture place everyone seeks first"},{"property":"twitter:image","content":"https:\u002F\u002Fmakeuni2026.com\u002Fimage\u002Fmakestar_logo_og_v2.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"prefetch","type":"font\u002Feot","href":"\u002Ffont\u002Fmakestar.eot"},{"rel":"prefetch","type":"font\u002Fttf","href":"\u002Ffont\u002Fmakestar.ttf"},{"rel":"prefetch","type":"font\u002Fwoff","href":"\u002Ffont\u002Fmakestar.woff"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_474c533f === 'function') {
    await nuxt_plugin_plugin_474c533f(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_3d617a7d === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_3d617a7d(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_10581ceb === 'function') {
    await nuxt_plugin_gtm_10581ceb(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescreen_8fa8f020 === 'function') {
    await nuxt_plugin_vuescreen_8fa8f020(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_88915a6e === 'function') {
    await nuxt_plugin_markdownit_88915a6e(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_490c8a68 === 'function') {
    await nuxt_plugin_dayjsplugin_490c8a68(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7859ee06 === 'function') {
    await nuxt_plugin_pluginutils_7859ee06(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7f9711d1 === 'function') {
    await nuxt_plugin_pluginrouting_7f9711d1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_d1cad984 === 'function') {
    await nuxt_plugin_pluginmain_d1cad984(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedaumpostcode_79a614cd === 'function') {
    await nuxt_plugin_vuedaumpostcode_79a614cd(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_884bb656 === 'function') {
    await nuxt_plugin_axios_884bb656(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_63d3f13a === 'function') {
    await nuxt_plugin_moment_63d3f13a(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_52fe1760 === 'function') {
    await nuxt_plugin_deviceplugin_52fe1760(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (typeof nuxt_plugin_index_e8a85358 === 'function') {
    await nuxt_plugin_index_e8a85358(app.context, inject)
  }

  if (typeof nuxt_plugin_actChart_0d097f3c === 'function') {
    await nuxt_plugin_actChart_0d097f3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_5f280597 === 'function') {
    await nuxt_plugin_vueinfiniteloading_5f280597(app.context, inject)
  }

  if (typeof nuxt_plugin_vueemojipicker_799f5465 === 'function') {
    await nuxt_plugin_vueemojipicker_799f5465(app.context, inject)
  }

  if (typeof nuxt_plugin_vueuuid_76fc2442 === 'function') {
    await nuxt_plugin_vueuuid_76fc2442(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_6da200de === 'function') {
    await nuxt_plugin_vueyoutube_6da200de(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecssdonutchart_d9faf16a === 'function') {
    await nuxt_plugin_vuecssdonutchart_d9faf16a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vawesomeswiper_3c4ab670 === 'function') {
    await nuxt_plugin_vawesomeswiper_3c4ab670(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_026ea236 === 'function') {
    await nuxt_plugin_vlazyload_026ea236(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmasonry_b03acc82 === 'function') {
    await nuxt_plugin_vmasonry_b03acc82(app.context, inject)
  }

  if (typeof nuxt_plugin_vfriendlyiframe_bc350d44 === 'function') {
    await nuxt_plugin_vfriendlyiframe_bc350d44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtoastification_598b949a === 'function') {
    await nuxt_plugin_vtoastification_598b949a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsdatepicker_061a20f2 === 'function') {
    await nuxt_plugin_vuejsdatepicker_061a20f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollpicker_5fb780ff === 'function') {
    await nuxt_plugin_vuescrollpicker_5fb780ff(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2datepicker_4e082fe0 === 'function') {
    await nuxt_plugin_vue2datepicker_4e082fe0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vkakaosdk_ea765698 === 'function') {
    await nuxt_plugin_vkakaosdk_ea765698(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2touchevent_00a83936 === 'function') {
    await nuxt_plugin_vue2touchevent_00a83936(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontawesomeicons_36ca5133 === 'function') {
    await nuxt_plugin_fontawesomeicons_36ca5133(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_d6afc2c2 === 'function') {
    await nuxt_plugin_vuetify_d6afc2c2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63638066 === 'function') {
    await nuxt_plugin_gtm_63638066(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0a2cb1e4 === 'function') {
    await nuxt_plugin_gtag_0a2cb1e4(app.context, inject)
  }

  if (typeof nuxt_plugin_dataDog_86d7e10a === 'function') {
    await nuxt_plugin_dataDog_86d7e10a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedState_1da1c1a3 === 'function') {
    await nuxt_plugin_persistedState_1da1c1a3(app.context, inject)
  }

  if (typeof nuxt_plugin_commonRouter_58daaba6 === 'function') {
    await nuxt_plugin_commonRouter_58daaba6(app.context, inject)
  }

  if (typeof nuxt_plugin_msw_4efc7088 === 'function') {
    await nuxt_plugin_msw_4efc7088(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
